/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { listUserObjectsGetResponseSchema } from './listUserObjectsGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getListUserObjects200Schema = z.lazy(() => listUserObjectsGetResponseSchema);

/**
 * @description 505 response
 */
export const getListUserObjects505Schema = z.any();

export const getListUserObjectsQueryResponseSchema = z.lazy(() => getListUserObjects200Schema);
